import { rootApi } from 'root-api-graphql'

const StartAIEnrichmentEmailMutation = `
  mutation StartAIEnrichmentEmail {
    startAIEnrichmentEmail
  }
`

const GetContactsSettingsQuery = `
  query GetContactsSettings {
    getContactsSettings {
      calendlyBookingEnabled
      notetakerEnabled
      gmailEnabled
      excludedDomainsAndEmails
    }
  }
`

const GetGoogleFormsImportContextQuery = `
  query GetGoogleFormsImportContext {
    googleFormsImportContext {
      isConnected
      forms {
        id
        title
        isAlreadyConnected
      }
    }
  }
`

const DisconnectGoogleFormsAccountMutation = `
  mutation DisconnectGoogleFormsAccount($input: ProviderAccountDeleteType!) {
    disconnectGoogleFormsAccount(input: $input)
  }
`

const UpdateContactsSettingsMutation = `
  mutation UpdateContactsSettings($input: ContactsSettingsInput!) {
    updateContactsSettings(input: $input) {
      calendlyBookingEnabled
      notetakerEnabled
      gmailEnabled
      excludedDomainsAndEmails
    }
  }
`

const GetEmailDigestPreferencesQuery = `
  query GetEmailDigestPreferences {
    emailDigestPreferences {
      meetingPrep {
        enabled
      }
    }
  }
`

const UpdateEmailDigestPreferencesMutation = `
  mutation UpdateEmailDigestPreferences($input: EmailDigestPreferencesInput!) {
    updateEmailDigestPreferences(input: $input) {
      meetingPrep {
        enabled
      }
    }
  }
`

const getBaseUrl = () => {
  const value = typeof window !== 'undefined' && window.OAP_API_GRAPHQL_BASE
  return (value && String(value)) || '/api/oap-api/graphql'
}

const api = rootApi.enhanceEndpoints({
  addTagTypes: ['ContactsSettings', 'GoogleFormsImportContext', 'EmailDigestPreferences'],
}).injectEndpoints({
  endpoints: (build) => ({
    startAIEnrichmentEmail: build.mutation({
      query: () => ({
        document: StartAIEnrichmentEmailMutation,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true },
      }),
    }),
    getContactsSettings: build.query({
      query: () => ({
        document: GetContactsSettingsQuery,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
      providesTags: ['ContactsSettings'],
    }),
    getGoogleFormsImportContext: build.query({
      query: () => ({
        document: GetGoogleFormsImportContextQuery,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
      providesTags: ['GoogleFormsImportContext'],
    }),
    disconnectGoogleFormsAccount: build.mutation({
      query: (input) => ({
        document: DisconnectGoogleFormsAccountMutation,
        variables: { input },
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
    }),
    updateContactsSettings: build.mutation({
      query: (input) => ({
        document: UpdateContactsSettingsMutation,
        variables: { input },
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
    }),
    getEmailDigestPreferences: build.query({
      query: () => ({
        document: GetEmailDigestPreferencesQuery,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
      providesTags: ['EmailDigestPreferences'],
    }),
    updateEmailDigestPreferences: build.mutation({
      query: (input) => ({
        document: UpdateEmailDigestPreferencesMutation,
        variables: { input },
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
      invalidatesTags: ['EmailDigestPreferences'],
    }),
  })
})

export const {
  useDisconnectGoogleFormsAccountMutation,
  useStartAIEnrichmentEmailMutation,
  useGetContactsSettingsQuery,
  useGetGoogleFormsImportContextQuery,
  useUpdateContactsSettingsMutation,
  useGetEmailDigestPreferencesQuery,
  useUpdateEmailDigestPreferencesMutation,
} = api

export const updateCachedContactsSettings = (updater) => api.util.updateQueryData('getContactsSettings', undefined, updater)
export const updateCachedGoogleFormsImportContext = (updater) => (
  api.util.updateQueryData('getGoogleFormsImportContext', undefined, updater)
)
